import React, {useState} from 'react';
import '../css/dataTable.css';
import { user } from '../Data/newUser.js';
import { useTable } from "../hooks/useTable";


function AboonneTable({ structure }) {

  const [searchTerm, setSearchTerm] = useState("");
  const itemsPerPage = 5;

  const { currentItems, filteredData, currentPage, paginate } = useTable(
    user,
    itemsPerPage,
    searchTerm
  );

  return (
    <div className="container">
    {/* En-tête avec titre et barre de recherche */}
    <div className="header-container">
      <h2 className="table-title">Liste des Abonnés de {structure.nom}</h2>
      <input
        type="text"
        placeholder="Rechercher un abonné..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="search-bar"
      />
    </div>

    {/* Tableau */}
    <table className="abonne-table">
      <thead>
        <tr>
          <th>Nom complet</th>
          <th>Categorie</th>
          <th>Cotisation</th>
          <th>date</th>
          <th>Statut</th>
        </tr>
      </thead>
      <tbody>
        {currentItems.map((user) => (
          <tr key={user.id}>
            <td>{user.nomComplet}</td>
            <td>{user.categorie}</td>
            <td>{user.cotisation}</td>
            <td>{user.date}</td>
            <td>
              <span className={`status ${user.Etat}`}>{user.Etat}</span>
            </td>
          </tr>
        ))}
      </tbody>
    </table>

    {/* Pagination */}
    <div className="pagination">
      {Array.from(
        { length: Math.ceil(filteredData.length / itemsPerPage) },
        (_, i) => (
          <button
            key={i + 1}
            onClick={() => paginate(i + 1)}
            className={currentPage === i + 1 ? "active" : ""}
          >
            
            {i + 1}
          </button>
        )
      )}
    </div>
  </div>
  )
}

export default AboonneTable